import React, { ReactElement } from 'react';

interface WYPIconProps {
  customStyle?: React.CSSProperties;
}

const WYPIcon = ({ customStyle }: WYPIconProps): ReactElement => {
  return (
    <svg width="25" height="49" viewBox="0 0 34 50" fill="none" xmlns="http://www.w3.org/2000/svg" style={customStyle}>
      <path
        d="M33.6412 5.06278L22.8888 15.7714C19.6497 18.9972 14.3811 18.9972 11.142 15.7714L0.348508 5.06278C0.215255 4.93008 0 5.02195 0 5.2057V47.2744C0 48.775 1.21978 50 2.73681 50H31.2632C32.77 50 34 48.7852 34 47.2744V5.2057C34 5.02195 33.7745 4.93008 33.6515 5.06278H33.6412Z"
        fill="#E21D4A"
      />
      <path
        d="M25.2226 34.7814L24.9744 35.0295C24.9744 35.0295 17.854 40.9255 17 43C16.146 40.9255 9.02565 35.0295 9.02565 35.0295L8.77738 34.7814C6.69193 32.697 6.35429 29.3222 8.23119 27.0591C10.3762 24.4585 14.2393 24.3195 16.573 26.6521L17 27.0789L17.427 26.6521C19.7607 24.3195 23.6238 24.4585 25.7688 27.0591C27.6457 29.3321 27.3081 32.7069 25.2226 34.7814Z"
        fill="white"
      />
      <path
        d="M20.6917 13.4966L33.9359 0.351906C34.0714 0.217354 33.9776 0 33.7899 0H0.210137C0.0224237 0 -0.0714326 0.227704 0.0641377 0.351906L13.2979 13.4863C15.3314 15.5046 18.6581 15.5046 20.6917 13.4863"
        fill="#C0103E"
      />
    </svg>
  );
};

export default WYPIcon;
